// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3m1B6","errorLogs":"styles_errorLogs__ab0zZ"};